/**
 * @generated SignedSource<<c56920ce3f707a34b03d6d634fd8c519>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type CheckoutSidebar_buyer$data = {
  readonly addressBook: {
    readonly addressList: ReadonlyArray<{
      readonly country: string | null;
      readonly serviceId: string | null;
    } | null> | null;
  } | null;
  readonly hasAnyTradeStatus: boolean | null;
  readonly serviceId: string | null;
  readonly " $fragmentSpreads": FragmentRefs<"CheckoutSidebarItemInfo_buyer" | "CheckoutSidebarProjectPane_buyer" | "CheckoutTaxExemption_buyer" | "CheckoutTotals_buyer">;
  readonly " $fragmentType": "CheckoutSidebar_buyer";
};
export type CheckoutSidebar_buyer$key = {
  readonly " $data"?: CheckoutSidebar_buyer$data;
  readonly " $fragmentSpreads": FragmentRefs<"CheckoutSidebar_buyer">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "serviceId",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "CheckoutSidebar_buyer",
  "selections": [
    {
      "alias": "hasAnyTradeStatus",
      "args": null,
      "kind": "ScalarField",
      "name": "isVerifiedTrade",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "CheckoutSidebarItemInfo_buyer"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "CheckoutTotals_buyer"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "CheckoutTaxExemption_buyer"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "CheckoutSidebarProjectPane_buyer"
    },
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "AddressBook",
      "kind": "LinkedField",
      "name": "addressBook",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "Address",
          "kind": "LinkedField",
          "name": "addressList",
          "plural": true,
          "selections": [
            (v0/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "country",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "User",
  "abstractKey": null
};
})();

(node as any).hash = "d4789623b2f47ad91ba02aed0702198c";

export default node;
